import {APIStatus} from '@web/core/constants'
import {getSaleChannelType} from '@web/slices/common/slice'
import makeSlice from '@web/slices/common/sliceMaker'
import {initDeliveryTracking} from '@web/slices/deliveryTracking/slice'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initDeliveryTracking.pending, (state) => {
                state.scene = APIStatus.FETCHING
                state.pageSet = 'DELIVERY_TRACKING'
            })
            .addCase(initDeliveryTracking.fulfilled, (state, {payload}) => {
                state.scene = APIStatus.RESOLVED

                if (payload.orderDelivery) {
                    state.entry = getSaleChannelType(payload.orderDelivery.productOrder.saleChannelType)
                }
            })
            .addCase(initDeliveryTracking.rejected, (state) => {
                state.scene = APIStatus.REJECTED
            })
    },
})

export default slice.reducer
